import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PiecesSection from "@/components/feature/PiecesSection";
import ServicesSection from "@/components/feature/ServicesSection";
import { getVillePieces, getVilleServices } from "@/mocks/servicesSections";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import ContactForm from "@/pages/home/components/ContactForm";
import GoogleReviews from "@/components/feature/GoogleReviews";
import Hero from "./components/Hero";
import LocalIntro from "./components/LocalIntro";
import InterventionsGrid from "./components/InterventionsGrid";
import FAQ from "./components/FAQ";
import Gallery from "./components/Gallery";
import InternalLinks from "./components/InternalLinks";
import FloatingButton from "./components/FloatingButton";

export default function ReparationFenetreBischheimPage() {
  useSEO(seoData.reparationFenetreBischheim);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <PiecesSection {...getVillePieces("Bischheim")} />
        <ServicesSection {...getVilleServices("Bischheim")} />
        <LocalIntro />
        <InterventionsGrid />
        <FAQ />
        <Gallery />
        <InternalLinks />
        <GoogleReviews />
        <ContactForm endpoint="https://formspree.io/f/mdajjjpn" formId="devis-form-bischheim" />
      </main>
      <Footer />
      <FloatingButton />
    </>
  );
}